import React, { useEffect, useState } from "react";
import CalculatorLayout from "../components/CalcLayout";
import GstCalc from "./GstCalc";
import Vat from "./Vat";
import { setActiveCalculator } from "../redux/calculations/calculaterSlice";
import { useDispatch, useSelector } from "react-redux";
import useLocale from "../../src/locales/index";
import { Helmet } from "react-helmet";
import { setActiveTab } from "../redux/aiAnalysis/aiAnalysisSlice";
const Gstboard = ({ setShowTable, resetAllValues }) => {
  const { activeCalculator } = useSelector((state) => state.calculator);
  const dispatch = useDispatch();
  const { textData } = useLocale();
  const [calcDone, setCalcDone] = useState(false);
  useEffect(() => {
    if (
      !activeCalculator ||
      (activeCalculator !== "GSTCalc" && activeCalculator !== "VatCalc")
    ) {
      dispatch(setActiveCalculator("GSTCalc"));
      dispatch(setActiveTab("GSTCalc"));
    }
  }, [dispatch, activeCalculator]);

  const handleTabChange = (tabIndex) => {
    const calculatorType = tabIndex === 0 ? "GSTCalc" : "VatCalc";
    dispatch(setActiveTab(calculatorType));
    if (activeCalculator !== calculatorType) {
      if (resetAllValues) resetAllValues();

      dispatch(setActiveCalculator(calculatorType));

      if (setShowTable) setShowTable(false);
      if (resetAllValues) resetAllValues();
    }
  };

  const currentTabIndex = activeCalculator === "GSTCalc" ? 0 : 1;

  const descriptionContent = (
    <div className="p-4 sm:p-5 w-full bg-[#F6F8FB] rounded-xl">
      <h2 className="text-black text-base sm:text-xl font-medium">
        {" "}
        {textData.gstContent.title}
      </h2>
      <p className="leading-relaxed mt-2  text-sm sm:text-[15px]">
        {textData.gstContent.description}
      </p>

      <h2 className="text-black text-base sm:text-xl font-medium mt-5">
        {" "}
        {textData.gstContent.howItWorksTitle}
      </h2>
      <p className="leading-relaxed mt-2 text-sm sm:text-[15px]">
        {textData.gstContent.howItWorksDescription}
      </p>

      <div>
        <p className="font-medium bg-[#E0E4F0] text-sm sm:text-base p-3 mt-3">
          <strong> {textData.gstContent.tax}:</strong>
          <br />
          {textData.gstContent.exclusive.gstAmount}
          <br />
          {textData.gstContent.exclusive.finalPrice}
          <br />
          <br />
          <strong> {textData.gstContent.removeInc}:</strong>
          <br />
          {textData.gstContent.inclusive.gstAmount}
          <br />
          {textData.gstContent.inclusive.basePrice}
        </p>
      </div>

      <table className="border-collapse mt-4 w-full">
        <tbody>
          <tr>
            <td className="p-3 border border-gray-light w-1/3 font-bold text-sm sm:text-[15px]">
              {textData.gstContent.symbolsTable[0].symbol}
            </td>
            <td className="p-3 border border-gray-light w-2/3 text-sm sm:text-[15px]">
              {textData.gstContent.symbolsTable[0].description}
            </td>
          </tr>
          <tr className="bg-transparent">
            <td className="p-3 border border-gray-light w-1/3 font-bold text-sm sm:text-[15px]">
              {textData.gstContent.symbolsTable[1].symbol}
            </td>
            <td className="p-3 border border-gray-light w-2/3 text-sm sm:text-[15px]">
              {textData.gstContent.symbolsTable[1].description}
            </td>
          </tr>
          <tr className="bg-transparent">
            <td className="p-3 border border-gray-light w-1/3 font-bold text-sm sm:text-[15px]">
              {textData.gstContent.symbolsTable[2].symbol}
            </td>
            <td className="p-3 border border-gray-light w-2/3 text-sm sm:text-[15px]">
              {textData.gstContent.symbolsTable[2].description}
            </td>
          </tr>
        </tbody>
      </table>

      <h2 className="text-black text-base sm:text-xl font-medium mt-8">
        {" "}
        {textData.gstContent.gstVatTypesTitle}
      </h2>
      <ul className="list-disc px-5 leading-relaxed mt-3 text-sm sm:text-[15px]">
        <li>
          <strong>{textData.gstContent.gstVatTypes[0].type}:</strong>
          {textData.gstContent.gstVatTypes[0].description}
        </li>
        <li>
          <strong>{textData.gstContent.gstVatTypes[1].type}:</strong>
          {textData.gstContent.gstVatTypes[1].description}
        </li>
      </ul>

      <h2 className="text-black text-base sm:text-xl font-medium mt-8">
        {" "}
        {textData.gstContent.exampleTitle}
      </h2>

      <p className="leading-relaxed mt-2  text-sm sm:text-[15px]">
        {textData.gstContent.exContent}
      </p>
      <ul className="list-disc px-5 leading-relaxed mt-3 text-sm sm:text-[15px]">
        <li>
          <strong> {textData.gstContent.Exclusive}:</strong>{" "}
          {textData.gstContent.gst} = {textData.currency}3,000, Total ={" "}
          {textData.currency}28,000
        </li>
        <li>
          <strong> {textData.gstContent.Inclusive}:</strong>{" "}
          {textData.gstContent.gst} = {textData.currency}2,678.57,
          {textData.gstContent.basePrice} = {textData.currency}22,321.43
        </li>
      </ul>

      <h2 className="text-black text-base sm:text-xl font-medium mt-8">
        {" "}
        {textData.gstContent.benefitsTitle}
      </h2>
      <ul className="list-disc px-5 leading-relaxed mt-3 text-sm sm:text-[15px]">
        <li>{textData.gstContent.benefitsList[0]}</li>
        <li>{textData.gstContent.benefitsList[1]}</li>
        <li>{textData.gstContent.benefitsList[2]}</li>
        <li>{textData.gstContent.benefitsList[3]}</li>
        <li>{textData.gstContent.benefitsList[4]}</li>
      </ul>
    </div>
  );
  return (
    <>
      <Helmet>
        <title>Free Online GST Calculator for Quick Tax Calculation</title>
        <meta
          name="description"
          content="Quickly calculate your tax for free! Use our Free Online GST Calculator to manage taxes, save time, and manage business or personal finances stress-free."
        />
        <link
          rel="canonical"
          href="https://growlifefund.com/calculator/gst-tax-calculator"
        />

        <meta
          property="og:title"
          content="Free Online GST Calculator for Quick Tax Calculation"
        />
        <meta
          property="og:description"
          content="Quickly calculate your tax for free! Use our Free Online GST Calculator to manage taxes, save time, and manage business or personal finances stress-free."
        />
        <meta
          property="og:url"
          content="https://growlifefund.com/calculator/gst-tax-calculator"
        />
        <meta property="og:site_name" content="growlifefund" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en" />
        <meta
          property="og:image:alt"
          content="Free Online GST Calculator - GrowLifeFund"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>
      <CalculatorLayout
        title={
          <>
            <span className="text-black lg:text-xl sm:text-lg text-lg">
              {textData.your}{" "}
            </span>
            {textData.vatCalc.vatCalc}{" "}
            <span className="text-black lg:text-xl sm:text-lg text-lg">
              {textData.Amount}
            </span>
          </>
        }
        calcDone={calcDone}
        description={textData.vatCalc.description}
        descriptionContent={descriptionContent}
      >
        <div>
          <div className="md:max-w-64 w-full select-none">
            <div className="flex rounded-[100px] bg-[#F6F8FB] p-[8px]">
              <button
                className={`
                text-center sm:py-[9px] py-[8px] sm:px-[20px] sm:text-base w-full md:w-[140px] text-[16px] font-lato-medium-400 
                ${
                  activeCalculator === "GSTCalc"
                    ? "bg-[#6592CB] rounded-full text-white font-semibold"
                    : "bg-transparent text-[#6F7373]"
                }
              `}
                onClick={() => handleTabChange(0)}
                type="button"
              >
                {textData.vatCalc.gst}
              </button>
              <button
                className={`
                text-center sm:py-[9px] py-[8px] sm:px-[20px] sm:text-base w-full md:w-[140px] text-[16px] font-lato-medium-400 
                ${
                  activeCalculator === "VatCalc"
                    ? "bg-[#6592CB] rounded-full text-white font-semibold"
                    : "bg-transparent text-[#6F7373]"
                }
              `}
                onClick={() => handleTabChange(1)}
                type="button"
              >
                {textData.vatCalc.vat}
              </button>
            </div>
          </div>

          <div className=" h-full pb-10">
            {currentTabIndex === 0 ? (
              <GstCalc
                setShowTable={setShowTable}
                activeTab={currentTabIndex}
                setActiveTab={(tab) => handleTabChange(tab)}
                resetAllValues={resetAllValues}
                setCalcDone={setCalcDone}
              />
            ) : (
              <Vat
                setShowTable={setShowTable}
                activeTab={currentTabIndex}
                setActiveTab={(tab) => handleTabChange(tab)}
                resetAllValues={resetAllValues}
                setCalcDone={setCalcDone}
              />
            )}
          </div>
        </div>
      </CalculatorLayout>
    </>
  );
};

export default Gstboard;
